'use strict';

(function () {
  if (blz.organizationId !== '47') return;

  $('.tabs-header .tab').on('click', () => {
    const tabsScrollTop = $('.tabs-header').offset().top,
      tabsHeight = $('.tabs-header').height(),
      top = tabsScrollTop + tabsHeight;

    $('html, body').animate({ scrollTop: top }, 'slow');
  });
})();
